import React from 'react';
import ManagedPropertyPortfolio from '../../components/managed-properties/ManagedPropertyPortfolio';
import LandlordToolkitLayout from '../../components/landlord-toolkit/LandlordToolkitLayout';

const ManagedPropertiesPage: React.FC = () => {
  return (
    <LandlordToolkitLayout title="Managed Properties">
      <ManagedPropertyPortfolio showList />
    </LandlordToolkitLayout>
  );
};

export default ManagedPropertiesPage;
